import { Alert, Button } from 'antd';
import React from "react";
import { Link, useOutletContext, useRouteLoaderData } from 'react-router-dom';
import { generateRouteUrl } from '../../../library/constants/routes.js';
import style from './proof-requested.module.scss';

const ProofRequested = () => {
    const { orderDetails } = useRouteLoaderData('OrderManagerDetailsPage')
    const { getClientArtworks } = useOutletContext()
    return <div className={style.container}>
        <h3>Task for you</h3>
        <Alert message="Proof has been requested." type="info"
            action={
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button className={style.greenButton} onClick={getClientArtworks}>View Artwork</Button>
                    <Link to={generateRouteUrl('SendProofToCustomer', {
                        itemId: orderDetails.id,
                    })}>
                        <Button className={style.greenButton}>Send Proof To Customer</Button>
                    </Link>
                </div>
            }
        />
    </div>
}

export default ProofRequested;